<template>
    <div>
        <form class="form" ref="contactForm">
            <div class="form-group">

                <label for="first_names">First Name</label>
                <input v-model="form.first_names"
                       @blur="setContactName"
                       class="form-control"
                       type="text"
                       id="first_names"
                       name="first_names"
                       :class="{'is-invalid': form.errors.has('first_names')}">

                <span class="invalid-feedback" v-show="form.errors.has('first_names')">
                    {{ form.errors.get("first_names") }}
                </span>

            </div>

            <div class="form-group">
                <label for="last_name">Last Name</label>
                <input v-model="form.last_name"
                       class="form-control"
                       type="text"
                       id="last_name"
                       name="last_name"
                       :class="{'is-invalid': form.errors.has('last_name')}">

                <span class="invalid-feedback" v-show="form.errors.has('last_name')">
                    {{ form.errors.get("last_name") }}
                </span>
            </div>

            <div class="form-group">
                <label for="email">Email</label>
                <input v-model="form.email"
                       class="form-control"
                       type="email"
                       id="email"
                       name="email"
                       :class="{'is-invalid': form.errors.has('email')}">

                <span class="invalid-feedback"
                      v-show="form.errors.has('email')"> {{ form.errors.get("email") }}
                </span>
            </div>

            <div class="form-group">
                <div class="col-md-6 row">
                    <label for="mobile">Mobile</label>
                    <input v-model="form.mobile"
                           class="form-control"
                           type="text"
                           id="mobile"
                           name="mobile"
                           :class="{'is-invalid': form.errors.has('mobile')}">

                    <span class="invalid-feedback" v-show="form.errors.has('mobile')">
                        {{ form.errors.get("mobile") }}
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-12 flex items-center">
                    <checkbox v-model="form.represents_juristic_entity"
                              name="represents_juristic_entity">
                        <slot name="label" class="ml-3 select-none font-medium text-gray-700">
                            &nbsp;Represents a&nbsp;
                            <span v-if="form.represents_juristic_entity && form.juristic_type" class="font-bold">{{ form.juristic_type }}</span>
                            <span v-else>Juristic Entity</span>
                        </slot>
                    </checkbox>
                    <i class="mdi mdi-help-circle ml-1" data-toggle="tooltip"
                       title="If the contact is representing a juristic entity, select this option to capture the entity details."></i>
                </div>
            </div>

            <div v-show="form.represents_juristic_entity">
                <div class="form-group">
                    <label>Entity Type</label>
                    <el-select
                        id="juristic_type"
                        v-model="form.juristic_type" placeholder="Select Entity Type"
                        style="width: 100%">
                        <el-option key="none"
                                   label="None"
                                   value="">
                        </el-option>

                        <el-option
                            v-for="type in juristicEntityTypes"
                            :key="type"
                            :label="type"
                            :value="type">
                        </el-option>
                    </el-select>
                </div>

                <div class="form-group" id="juristic-entity-details">
                    <label>Entity Name</label>
                    <input v-model="form.juristic_name"
                           class="form-control"
                           type="text"
                           id="juristic_name"
                           name="juristic_name"
                           :class="{'is-invalid': form.errors.has('juristic_name')}">

                    <span class="invalid-feedback" v-show="form.errors.has('juristic_name')">
                        {{ form.errors.get("juristic_name") }}
                    </span>
                </div>

                <div class="form-group">
                    <label for="registration_number">Registration Nr.</label>
                    <input v-model="form.registration_number"
                           class="form-control"
                           type="text"
                           id="registration_number"
                           name="registration_number"
                           :class="{'is-invalid': form.errors.has('registration_number')}">

                    <span class="invalid-feedback" v-show="form.errors.has('registration_number')">
                        {{ form.errors.get("registration_number") }}
                    </span>
                </div>

                <div class="form-group">
                    <label for="vat_number">Vat Nr.</label>
                    <input v-model="form.vat_number"
                           class="form-control"
                           type="text"
                           id="vat_number"
                           name="vat_number"
                           :class="{'is-invalid': form.errors.has('vat_number')}">

                    <span class="invalid-feedback" v-show="form.errors.has('vat_number')">
                        {{ form.errors.get("vat_number") }}
                    </span>
                </div>
            </div>
        </form>

        <div class="flex justify-between items-center">
            <!--Cancel-->
            <button
                type="button"
                class="btn btn-default waves-effect"
                :disabled="form.busy"
                @click.prevent="$emit('cancel-contact-creation')">
                Cancel
            </button>
            <!--Create Contact-->
            <button
                class="btn btn-success waves-effect waves-light"
                @click.prevent="createContact"
                :disabled="form.busy"
            >
                {{ form.busy ? "Creating Contact..." : "Create Contact" }}
            </button>
        </div>
    </div>
</template>

<script>
import ContactFieldValidations from "../../mixins/contact-mixin";
import ContactFormListsMixin from "../../mixins/contact-form-lists-mixin";

export default {
    name: "CreateContactForLinkList",

    mixins: [ContactFieldValidations, ContactFormListsMixin],

    data () {
        return {
            form: new AppForm({
                represents_juristic_entity: false,
                contactable_id: this.contactableId,
                contactable: this.contactable,
            }),
            contactNameSet: false
        };
    },

    methods: {
        createContact () {
            App.post("/contacts/create", this.form)
            .then(response => {
                // This response is the newly created contact and used by the ContactLinkList
                // to auto-select the new contact in the remote search field.
                this.$emit("contact-created", response);
                toastr.success("New Contact Created!");
                this.initForm();
            })
            .catch(errors => {
                toastr.error("Creating Contact Failed!");
            });
        },

        initForm () {
            this.form = new AppForm({
                represents_juristic_entity: false,
                contactable_id: this.contactableId,
                contactable: this.contactable
            });
        },
    }
};
</script>

<style scoped>

</style>
